define("SDB.SDBLocations.View", [
  "SCView",
  "sdb_currentlocation_template.tpl",
  "SDB.SDBLocations.Model",
  "SDB.SDBLocations.Modal.View",
], function (
  SCViewComponent,
  currentlocation_tpl,
  SDBLocationModel,
  SDBLocationsModalView
) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBLocationsView(options) {
    SCView.call(this);

    this.options = options;
    this.template = currentlocation_tpl;
    this.model = SDBLocationModel.getInstance();

    this.events = {
      "click .sdb-locations-view__current-location:not(.disabled)":
        "showLocationsModal",
    };

    this.locations = this.model.getLocations();
    this.shoppingExperience = this.model.getShoppingExperience();

    if (
      !this.model.isLocationSelected() &&
      // && this.shoppingExperience !== 'online'
      !this.noChangeLocationStep
    ) {
      this.showLocationsModal();
    }

    this.attributes = { id: "SDBLocationsViewId", class: "sdb-locations-view" };

    this.model.on("change:location", this.render, this);
    this.model.on(
      "change:shoppingExperience",
      this.manageShoppingExperience,
      this
    );
  }

  SDBLocationsView.prototype = Object.create(SCView.prototype);
  SDBLocationsView.prototype.constructor = SDBLocationsView;

  SDBLocationsView.prototype.manageShoppingExperience = function () {
    if (this.model.getShoppingExperience() === "online") {
      this.model.removeLocation();
      this.render();
    }
  };

  /** @returns {SDB.SDBLocations.Layout }  */
  SDBLocationsView.prototype.getLayout = function () {
    return this.options.container.getComponent("Layout");
  };

  SDBLocationsView.prototype.showLocationsModal = function () {
    if (this.noChangeLocationStep) return;

    var modalView = new SDBLocationsModalView({
      container: this.options.container,
      view: this,
      pageHeader: "Select Your Shopping Experience",
      locations: this.locations,
    });

    this.getLayout()
      .showContent(modalView, { showInModal: true })
      .then(function (view) {
        //prevent closing the modal if no location is selected
        if (!view.model.getSelectedLocation()) {
          $("#modal").off("click");
          $("#modal").off("keyup");
          $("#modal").off("keydown");
        }

        //show locations right away
        var $locationsList = $('[data-role="locations-list-container"]');
        var $locations = $('[data-action="select-location"]');
        $locationsList.removeClass("hide");
        $locations.addClass("active");
      });
  };
  SDBLocationsView.prototype.showLocationsModal = _.debounce(
    SDBLocationsView.prototype.showLocationsModal,
    200
  );

  SDBLocationsView.prototype.getContext = function () {
    var contextValues = {
      // @property {String} currentLocation - The name of the current location
      currentLocation: this.model.isLocationSelected()
        ? this.model.getSelectedLocation().addrFields.city
        : "Shopping Online",
      isLocationSelected: this.model.isLocationSelected(),
      // noChangeLocationStep: this.noChangeLocationStep
    };
    // disable on the review step of the quote to sales order module
    if (
      Backbone.history.location.href.indexOf("quotetosalesorder-review") !== -1
    ) {
      contextValues.isReviewStep = true;
    }
    return contextValues;
  };

  return SDBLocationsView;
});
